<template>
    <div data-aos="fade-left" class="modal-wrapper">
        <div class="modal modal-sm">  
            <div class="modal-title modal-title-lg">
                <p>E-Mail-Verifizierung</p>
            </div>
 
            <div class="modal-msg modal-msg-sm modal-msg-blue">
                <p>
                    Wir haben dir einen Bestätigungscode per E-Mail gesendet. Bitte gib den Code unten ein, um fortzufahren.
                </p>                
            </div> 

            <div class="input-wrapper">
                <input 
                    type="text" 
                    placeholder="Code eingeben" 
                    v-model="confirmCode" 
                    :class="{'input-err': confirmCodeErr}"
                >
                <div class="err-icon" v-if="confirmCodeErr">
                    <img src="@/assets/icons/incorrect_icon.svg"/>
                </div>
                <div class="err-msg" v-if="confirmCodeErr">
                    <p v-for="error in v$.confirmCode.$errors" :key="error.$uid" >
                        {{error.$message}}
                    </p> 
                </div>
            </div>
             
  
            <!-- <button v-if="loadingBtn" class="modal-btn loading-btn">
                <div class="loader"></div>
            </button>
            <button v-else @click="sendEmail()" class="modal-btn">
                <p>Suchen</p>
            </button> -->


            <router-link to="/login" class="modal-btn modal-btn-sm"><p>Code bestätigen</p></router-link> 
        </div>
    </div>
</template>
<script> 
import useValidate from '@vuelidate/core';
import {
    required,
    helpers, 
} from "@vuelidate/validators";
export default {
    watch:{
        "confirmCode"(value) {
            if (value) {
                this.confirmCodeErr = false;
            } else {
                this.confirmCodeErr = true;
            }
        },
    },
    data(){
        return{
            v$: useValidate(),

            confirmCode: '',
            confirmCodeErr: false,
 
            loadingBtn: false,
        }
    },
    validations() {
        return { 
            confirmCode: {
                required: helpers.withMessage('Code eingeben ist erforderlich', required) 
            }, 
        }
    },
    methods:{
        sendEmail(){  
            this.loadingBtn = true;

            this.v$.confirmCode.$touch(); 

            this.confirmCodeErr = this.v$.confirmCode.$invalid;

            if (!this.confirmCodeErr) {
                this.loadingBtn = false; 
            }else{
                this.loadingBtn = false;
                this.confirmCode='';
                this.confirmCodeErr=false;
            } 
        }
    }
}
</script>
<style scoped lang="scss">
@import "@/assets/modals.scss"; 
.user-identity{
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1000;
}
.mail-animation{
    width: 126px;
    height: 202px;
    margin: 0 auto;
    margin-bottom: 37px;
    margin-top: -70px;
} 
 
.modal-btn{ 
    margin-bottom: 32px; 
    position: relative; 
    border-radius: 14px;

    img{
        width: 16px;
        height: 10px;
        position: absolute;
        top: 50%;   
        right: 10px;  
        transform: translate(-50%, -50%);
    }
} 


.modal-msg-pink{
    margin-bottom: 0;
}

/* imac 24" */
/* 2048 x 1152 */
@media (min-width: 2048px) {
}

/* 2304-1470 */
@media (min-width: 2304px) {
    .modal-btn{  
        img{
            width: 18px;
            height: 12px;
            right: 8px; 
        }
    }
}

/* 2470 - 1328 */
@media (min-width: 2470px) {
}

/* imac retina */
/*2560-1440*/
@media (min-width: 2560px) {
    .mail-animation{
        width: 140px;
        height: 220px; 
    } 
    
    .modal-btn{ 
        margin-bottom: 35px; 
    } 
}

/*2573-1206*/
@media(min-width: 2573px) {
}

/* 2880-1670 */
@media(min-width: 2880px) {
    .mail-animation{
        width: 160px;
        height: 240px; 
    } 
    
    .modal-btn{ 
        margin-bottom: 40px; 
        img{
            width: 20px;
            height: 14px; 
        }
    }  
}

/* 3000-1870 */
@media(min-width: 3000px) {
}

/*3200-1800*/
@media(min-width: 3200px) {
    .mail-animation{
        width: 180px;
        height: 260px; 
    } 
    
    .modal-btn{ 
        margin-bottom: 45px; 
        img{
            width: 22px;
            height: 16px; 
        }
    } 
}

/*3360-1890 1695*/
@media(min-width:3360px) { 
    .mail-animation{
        width: 190px;
        height: 270px; 
    }  
}

/* 3840 x 2160 2049 (4K) */
@media(min-width:3840px){
    .mail-animation{
        width: 240px;
        height: 320px; 
    } 
    
    .modal-btn{ 
        margin-bottom: 55px; 
        img{
            width: 26px;
            height: 20px; 
        }
    } 
}

/* 1920x961 (current) */

/* macbook pro 16 2021 */
/*1728x1085*/
@media(max-width: 1728px) {
}

/*1688-1080*/
@media(max-width: 1688px) {
    .mail-animation {
        width: 120px;
        height: 190px;
    }
}

/*1680-1080*/
@media(max-width: 1680px) {
}

/*1640-1080*/
@media(max-width: 1640px) {
    .mail-animation {
        width: 110px;
        height: 180px;
    }
}

/* 1600 - 757 */
@media (max-width: 1600px) {
    .modal-btn img {
        width: 14px;
        height: 8px;  
        right: 12px; 
    }
}

/*1536-864*/
@media(max-width:1536px) {
    .mail-animation {
        width: 100px;
        height: 170px;
    }
}

/* macbook pro/air */
/* 1440-900 */
@media(max-width:1440px) {
}

/*1366-638*/
@media (max-width:1366px) {
}

/* macbook air */
/* 1280-800 */
@media (max-width:1280px) {
    .mail-animation {
        width: 90px;
        height: 160px;
    }
}

/* 1200-1920 */
@media (max-width:1200px) {
}

/*1134x712*/
@media(max-width:1134px) {
}


/* tablets */

/* micro duo */
/*1114x705*/
@media(max-width:1114px) {
}

/*1024-768*/
/* ipad pro */
/*1024-1366*/
@media (max-width:1024px) {
}

/* ipad pro 2/3 */
/* 981x1024 */
@media (max-width:981px) {
}

/* 962x601 */
@media(max-width: 962px) {
    .mail-animation { 
        margin-bottom: 25px;
        margin-top: -50px;
    }
}

/* 900x1600 */
@media(max-width: 900px) {
}

/* galaxy fold */
/* 884 x 1104 */
@media(max-width: 884px) {
}

/* ipad pro 2022 */
/*834-1136*/
@media(max-width: 834px) {
}

/* ipad air 4 */
/* 820x1180 */
@media(max-width: 820px) {
}

/* ipad 2020 */
/* 810x1080 */
@media(max-width: 810px) {
}

/* galaxy tab 7 */
/* 800x1280 */
@media(max-width: 800px) {
}

/*778-304*/
@media(max-width: 778px) {}

/*775*/
@media(max-width: 775px) {}

/* ipad air/mini */
/* 768x1024 */
@media(max-width: 768px) {
    .mail-animation { 
        width: 80px;
        height: 150px;
        margin-bottom: 15px;
        margin-top: -40px;
    } 
}

/*712-1138*/
@media(max-width:712px) {
}

/* ipad air 2/3 */
/* 694-768 */
@media(max-width:694px) {
}

/* ipad pro 1/2 */
/* 678-1024 */
@media(max-width:678px) {
}

/* 600x962 */
@media(max-width:600px) {
}

/* 577-951 */
@media(max-width:577px) {    
}

/* 540-960 */
@media(max-width:540px) {
    .mail-animation { 
        width: 70px;
        height: 120px; 
    } 

    .modal-btn img { 
        right: 8px; 
    }
}


/* mobiles */

/* s-note */
/*480-853*/
@media (max-width:480px) {
}

/* ipad air 2/3 */
/*438-1024*/
@media(max-width:438px) {
    .mail-animation { 
        width: 63px;
        height: 120px;
        margin-bottom: 0px;
        margin-top: -30px;
    } 

    .modal-sm { 
        padding: 30px 10px;
    }

    .modal-footer .modal-msg p{
        text-align: center;
    }
}

/* ip14 pro max */
/* 430x932 */
@media(max-width:430px){
}

/* ip13 pro max */
/* 428-926 */
@media (max-width:428px){
}

/* ip11 pro max */
/* 414-896/736*/
@media (max-width:414px) {
}

/* s21 ultra, pix6 */
/* 412-915*/
/* heights: 732, 824, 846, 869, 892, 906, 915, 919 */
@media (max-width:412px) { 
}

/* ip14 pro, pix5 */
/*393 x 852*/
@media(max-width:393px) {}

/* ip13 pro */
/*390 x 844*/
@media(max-width:390px) {
}

/* s21 plux */
/*384-854*/
@media(max-width:384px) {
    .modal-sm { 
        padding: 20px 10px;
    }
}

/* ip X */
/*375-812/667*/
@media(max-width:375px) {
}

/* s22 ultra */
/*360x772*/
@media(max-width:360px) {
    .mail-animation { 
        width: 50px;
        height: 100px;
        margin-bottom: 0px;
        margin-top: -30px;
    } 

    .modal-sm { 
        padding: 20px 5px;
    }
}

/* ip SE */
/*320x568*/
@media(max-width:320px) {
}
</style>